// Ported from cartadigital-pos app/domain/pricing/tax.ts — keep in behavioral
// parity with backend OrderUtils.getOrderTotals / applyTax().
import { TaxDisplayMode } from '@/enums/TaxDisplayMode';

export interface IApplyTaxInput {
  taxPercent: number | null | undefined;
  taxMode: TaxDisplayMode;
  price: number;
  partial: boolean;
  forced?: boolean;
}

/**
 * Ported from `cartadigital-api/src/utilities/orders.utils.ts` `applyTax()`.
 *
 * Important: keep semantics identical for pricing parity.
 */
export function applyTax({
  taxPercent,
  taxMode,
  price,
  partial,
  forced,
}: IApplyTaxInput): number {
  const t = typeof taxPercent === 'number' ? taxPercent : null;

  if (
    t == null ||
    !Number.isFinite(t) ||
    t <= 0 ||
    taxMode === TaxDisplayMode.NoTax
  ) {
    return price;
  }

  const factor = 1 + t / 100;

  if (forced) {
    return price * factor;
  }

  if (partial) {
    if (
      taxMode === TaxDisplayMode.AddAndShow ||
      taxMode === TaxDisplayMode.SilentAdd
    ) {
      return price * factor;
    }
  } else {
    if (taxMode === TaxDisplayMode.AddAtInvoice) {
      return price * factor;
    }
  }

  return price;
}
